import { type App } from 'vue';
import i18next from './i18n';

export const helpLink = (code: string) =>
  `http://help.cutr.ai/${i18next.resolvedLanguage}/articles/${code}`;

const HelpLinksPlugin = {
  install(app: App) {
    app.config.globalProperties.$helpLink = helpLink;
  },
};

export default HelpLinksPlugin;
